import styled from 'styled-components/macro';

export const Inner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: ${({ direction }) => direction};
  max-width: 1100px;
  margin: auto;
  width: 100%;

  @media (max-width: 1000px) {
    flex-direction: column;
  }
`;

export const Pane = styled.div`
  width: 50%;

  @media (max-width: 1000px) {
    width: 100%;
    padding: 0 45px;
    text-align: center;
  }
`;

export const Title = styled.h1`
  font-size: 40px;
  line-height: 1.1;
  margin-bottom: 8px;
  color: var(--color-blue);

  &:hover {
    color: var(--color-red);
  }

  @media (max-width: 600px) {
    font-size: 30px;
  }
`;

export const SubTitle = styled.h2`
  font-size: 22px;
  font-weight: normal;
  line-height: normal;
  opacity:0.7;

  @media (max-width: 600px) {
    font-size: 18px;
  }
`;

export const Image = styled.img`
  max-width: 100%;
  height: auto;
  padding:2rem;

`;

export const Item = styled.div`
  display: flex;
  /* border-top: 4px solid #222; */
  padding: 50px 5%;
  color: black;
  overflow: hidden;
`;

export const Container = styled.div`
  @media (max-width: 1000px) {
    ${Item}:last-of-type h2 {
      margin-bottom: 50px;
      margin-top: 50px;
    }
  }
`;
